import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=737d3b30&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
import style0 from "./Comments.vue?vue&type=style&index=0&id=737d3b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d3b30",
  null
  
)

export default component.exports